import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { BreakpointService, BreakpointServiceInjector } from '@next/core-lib/responsive';
import { Breadcrumb } from 'src/app/models/breadcrumb.model';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgFor, MatButton, MatIcon, AsyncPipe],
})
export class BreadcrumbComponent {
  @Input() rootTitle: string;

  @Output() readonly navigateToMainBreadcrumb: EventEmitter<void> = new EventEmitter();
  @Output() readonly navigateToBreadcrumb: EventEmitter<number> = new EventEmitter();

  allBreadcrumbs: Breadcrumb[];
  lastBreadcrumb: Breadcrumb | undefined;

  constructor(@Inject(BreakpointServiceInjector) readonly breakpointService: BreakpointService) {}

  @Input() set breadcrumbs(crumbs: Breadcrumb[]) {
    this.allBreadcrumbs = crumbs || [];
    this.lastBreadcrumb = this.allBreadcrumbs[this.allBreadcrumbs.length - 1];
  }

  navigateToSecondToLastBreadcrumb() {
    if (this.allBreadcrumbs.length) {
      const newBreadcrumbNumber = this.allBreadcrumbs.length - 2;
      if (newBreadcrumbNumber >= 0) {
        this.navigateToBreadcrumb.emit(newBreadcrumbNumber);
      } else {
        this.navigateToMainBreadcrumb.emit();
      }
    }
  }
}
